export default "__VITE_ASSET__e77f6869__"